import { useEffect } from "react";
import { useUserStore } from "@/store/use-user-store";
import { useUserInfo } from "@/hooks/use-user-info";
import { useRouter } from "next/router";
import { ECookieKeys } from "@/const/cookie-keys.const";
import Cookies from "js-cookie";
export const InitUser = () => {
  const hasHydrated = useUserStore((s) => s._hasHydrated);
  const userInfo = useUserStore((s) => s.userInfo);
  const setUserInfo = useUserStore((s) => s.setUserInfo);
  const { refetch } = useUserInfo();
  const router = useRouter();
  useEffect(() => {
    if (!hasHydrated) return;
    // if (!userInfo && Cookies.get(ECookieKeys.TOKEN)) {
    //   refetch().then((res) => {
    //     if (res.data) {
    //       if (!res.data?.data?.user?.company?.id) {
    //         router.replace(
    //           `/auth/register-company?userId=${res.data?.data?.user?.id}`
    //         );
    //       } else if (!res.data?.data?.user?.plan_detail?.plan_id) {
    //         router.replace(`/contract?userId=${res.data?.data?.user?.id}`);
    //       } else {
    //         router.replace("/customer/list");
    //       }
    //       setUserInfo(res.data?.data?.user);
    //     }
    //   });
    // }
  }, [hasHydrated, userInfo]);

  return null;
};
